// extracted by mini-css-extract-plugin
module.exports = {"drag_start":"TopBar_drag_start__1jcus","disabled":"TopBar_disabled__3qlR0","counter_wrapper":"TopBar_counter_wrapper__3MpUP","read_only_counter":"TopBar_read_only_counter__gXPl2"};